export const ENDPOINTS = {
  LOGIN: "/auth/login",
  REGISTER: "/auth/register",
  CHIP: "/game/chip",
  PLACE_BET: "/game/bet-place",
  GAME_HISTORY: "/game/history",
  BALANCE: "/wallet/balance",
  DEPOSIT: "/wallet/deposit",
  PROFILE: "/user/profile",
  RESULTS: "/game/results",
  MY_BETS: "/game/my-bets",
};
